import { createFileRoute } from '@tanstack/react-router';
import { Trans } from 'react-i18next';
import {
  Box,
  DialogContent,
  Stack,
  Typography,
  Dialog,
  Grow,
} from '@mui/material';
import { forwardRef } from 'react';
import { useGetSpacing } from '@ui';
import { YourNiveaCremeLogo } from '@components';

import Image from '/bg2.jpg';
import { TransitionProps } from '@mui/material/transitions';

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Grow ref={ref} {...props} />;
});

const Homepage = () => {
  const getSpacing = useGetSpacing();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'primary.light',
        backgroundImage: `url(${Image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: 4,
      }}
    >
      <Dialog
        open={true}
        scroll={'body'}
        fullWidth={true}
        slots={{
          transition: Transition,
        }}
      >
        <DialogContent
          sx={{
            paddingTop: getSpacing('xl'),
            paddingRight: getSpacing('xl'),
            paddingBottom: getSpacing('xxl'),
            paddingLeft: getSpacing('xl'),
          }}
        >
          <Stack
            spacing={getSpacing('l')}
            sx={{ width: '100%', maxWidth: '100%' }}
          >
            <YourNiveaCremeLogo />
            <Typography sx={{ fontSize: 18, fontWeight: 400 }}>
              <Trans i18nKey="homepage.scanQrCode" />
            </Typography>
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export const Route = createFileRoute('/')({
  component: Homepage,
});
